// Idade do envolvido: sempre em relação a hoje (é a idade da pessoa, não da
// ocorrência — segue avançando mesmo se a ocorrência for reaberta depois).

export function ageFromBirthDate(birthDateStr) {
  // Parse manual do "YYYY-MM-DD" (em vez de `new Date(str)`, que interpreta
  // datas sem hora como UTC): evita um off-by-one de 1 dia dependendo do
  // fuso do navegador, já que aqui comparamos com `today` em hora local.
  const [y, m, dd] = String(birthDateStr).split('-').map(Number)
  if (!y || !m || !dd) return { years: null, months: null, days: null }
  const birth = new Date(y, m - 1, dd)

  const today = new Date()
  let years = today.getFullYear() - birth.getFullYear()
  let months = today.getMonth() - birth.getMonth()
  let days = today.getDate() - birth.getDate()

  if (days < 0) {
    months -= 1
    days += new Date(today.getFullYear(), today.getMonth(), 0).getDate()
  }
  if (months < 0) {
    years -= 1
    months += 12
  }
  return { years, months, days }
}

export function formattedAge({ birth_date: birthDate, age, age_unit: ageUnit } = {}) {
  if (birthDate) {
    const { years, months, days } = ageFromBirthDate(birthDate)
    if (years === null) return ''
    return `${years} ${years === 1 ? 'ano' : 'anos'}, `
      + `${months} ${months === 1 ? 'mês' : 'meses'} e `
      + `${days} ${days === 1 ? 'dia' : 'dias'}`
  }
  if (age !== null && age !== undefined && age !== '') {
    return `${age} ${ageUnit || 'anos'}`
  }
  return ''
}

export function genderLabel(gender) {
  return { M: 'Masculino', F: 'Feminino', O: 'Outro' }[gender] || ''
}
